import React, { useEffect, useState } from "react";
import { Tooltip, useMap } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import TextPolyline from "../modules/TextOnEachSegmentPolyline";
import { useSelector, useDispatch } from "react-redux";
import { setDistances } from "../../store/reducers/helpersReducer";
import L from 'leaflet';



export const LayerFider110 = props => {
    const map = useMap();
    const dispatch = useDispatch()

    const [mapState, setMapState] = useState({ zoom: map.getZoom(), bounds: map.getBounds() });

    // Подписываемся на события карты для обновления при перемещении/зуме
    useEffect(() => {
        const handleMapChange = () => {
            setMapState({ zoom: map.getZoom(), bounds: map.getBounds() });
        };

        map.on('zoomend', handleMapChange);
        map.on('moveend', handleMapChange);

        return () => {
            map.off('zoomend', handleMapChange);
            map.off('moveend', handleMapChange);
        };
    }, [map]);
    const { fider110 } = useSelector(
        (state) => state.state.electricity
    );

    useEffect(() => {
        let distance = 0
        if (fider110) {
            fider110.map(f => {
                f.coordinates.map((c, i) => {
                    if (i == 0) {
                        distance += 0
                    } else {
                        const from = new L.latLng(c[0], c[1])
                        const to = new L.latLng(f.coordinates[i - 1][0], f.coordinates[i - 1][1])
                        distance += from.distanceTo(to)
                    }
                })
            })
        }
        dispatch(setDistances({ layer: 'fider110', distance: (distance / 1000).toFixed(0) }))
    }, [fider110])

    if (!fider110) {
        return <></>
    }
    const markers = fider110.map((mark, idx) => {

        let south = mark.coordinates[0][0]
        let north = mark.coordinates[0][0]
        let east = mark.coordinates[0][1]
        let west = mark.coordinates[0][1]
        mark.coordinates.map(coord => {
            if (coord[0] < south) south = coord[0]
            if (coord[0] > north) north = coord[0]
            if (coord[1] < west) west = coord[1]
            if (coord[1] > east) east = coord[1]
        })
        const markBounds = new L.LatLngBounds(
            new L.LatLng(south, west),
            new L.LatLng(north, east)
        );

        if (!mapState.bounds.intersects(markBounds)) return null;

        return (
            <TextPolyline
                positions={mark.coordinates}
                // pane="fidersPane"

                key={`${mark.fid}_${idx}`}
                data={mark.fid}
                color="#8d5a99"
                weight={4.1}
                periodicText={mark.name}
                periodicTextColor={'#8d5a99'}
                periodicTextFontFamily={'Arial, sans-serif'}
                periodicTextFontSize={`14px`}
                periodicTextStroke={true}
                periodicTextStrokeWidth={2}
                periodicTextStrokeColor={"#ffffff"}
                periodicTextSpacing={200}
                periodicTextPosition={"middle"}
                periodicMaxTextCompressionPercent={70}
                periodicMinZoomForText={10}

            >
                <Tooltip key={`${mark.fid}_${idx}_tooltip`} sticky >{mark.name}</Tooltip>
            </TextPolyline>
            // <TextPolyline
            //     positions={mark.coordinates}
            //     text={mark.name}
            //     key={`${mark.fid}_${idx}`}
            //     zoom={zoom}
            //     color="#8d5a99"
            //     weight={4.3}
            //     // textColor='#778232'
            //     textColor='#8d5a99'
            //     textFont='bold italic 14px sans-serif'
            //     textOffset={0}
            //     textBold={false}
            //     textItalic={false}
            //     textStroke={true}
            //     textStrokeWidth={2}
            //     textStrokeColor='#ffffff'
            //     textPosition={'middle'}
            //     maxTextCompressionPercent={50}
            //     minZoomForText={10}
            //     data={mark.fid}


            // >

            //     {/* <MarkerPopup host={mark} key={`popup_${mark.fid}`} ps={props.ps ? props.ps.find(p => p.fid === mark.ps_id) : null} /> */}
            //     <Tooltip key={`${mark.fid}_${idx}_tooltip`} sticky >{mark.name}</Tooltip>
            // </TextPolyline>


        );
    }).filter(Boolean);
    return markers;
}